import React from "react";
// import logo from "./logo.svg";

import Cv from "./containers/Cv";
import PrintApp from "./containers/PrintApp";
import { HashRouter as Router, Route } from "react-router-dom";
// use BrowserRouter if the server supports html routes
function App() {
  return (
    <Router>
      <Route path="/" exact component={Cv} />
      <Route path="/print" exact component={PrintApp} />
    </Router>
  );
}

export default App;
